<div class="flex flex-col gap-4 py-5">

  <div class="flex flex-wrap items-center justify-between gap-3 pb-5 border-b border-gray-300">
    <h2 class="text-2xl font-semibold">{{ title }}</h2>
    <div class="flex flex-wrap gap-2">
      <ng-content select="[slot=actions]"></ng-content>
    </div>
  </div>

  <ng-content select="[slot=filters]"></ng-content>

  <ng-content></ng-content>

</div>
